module.exports = __webpack_public_path__ + "static/media/Almarai-ExtraBold.20c3062a.ttf";